import { useQuery } from "@tanstack/vue-query";
import { useExperienceRawApi } from "@/composables/useExperienceRawApi";

export const OPERATIONAL_EXPERIENCES_SEARCH_QUERY_KEY = "operational-experiences-search";

export function useOperationalExperiencesSearchQuery(codeRef: Ref<string>) {
  const { searchOperationalExperiences } = useExperienceRawApi();

  const isEnabled = computed(() => codeRef.value.length >= 4);

  return useQuery({
    queryKey: [OPERATIONAL_EXPERIENCES_SEARCH_QUERY_KEY, codeRef],
    queryFn: () => searchOperationalExperiences(codeRef.value),
    select: ({ data }) => data,
    enabled: isEnabled,
  });
}
